import React from "react";
import classNames from "classnames";
import { Button as _Button, ButtonProps as _ButtonProps } from "reactstrap";

export interface ButtonProps extends _ButtonProps {
  color?: "primary" | "secondary" | "dark" | "white" | "danger";
  size?: "sm" | "lg";
  niceParam?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  size,
  className,
  ...props
}) => (
  <_Button
    {...props}
    className={classNames(className, {
      "btn-sm": size === "sm",
      "btn-lg": size === "lg",
    })}
  >
    {children}
  </_Button>
);
